var escape = require("../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".acontainer{margin-bottom:15px;margin-top:15px}.ad-omnexio{border:1px solid #fff;max-width:220px;margin:auto;background-image:url(" + escape(require("../assets/ads/pattern.webp")) + ")}.acenter,.alogo,.atitle-omnexio{text-align:center;margin-top:.5rem;margin-bottom:.5rem}.atitle-omnexio a{color:#fff}.asubtitle-omnexio{text-align:center;margin:.5rem .2rem}.asubtitle-omnexio a{font-size:.9em;color:#fff}", ""]);

// exports
